// @flow
/* eslint-disable */
import MobileSettings, { TRAINER_SETTINGS_MAX_WIDTH } from '../../components/MobileSettings';
import React, { useEffect, useLayoutEffect, useMemo, useRef, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import Card from '../../components/Card';
import styles from './styles.module.scss';
import { H3, H4, P } from '../../components/Typography';
import routes from '../../constants/routes';
import PositionCircle from '../../components/PositionCircle';
import Spinner from '../../components/Spinner';
import { sortRawCards } from 'utils/game/sortRandomCards';
import PlayingCard from '../../components/PlayingCard';
import { Button } from '../../components';
import actionTypes from '../../store/game/actionTypes';
import actionTypesProfile from '../../store/profile/actionTypes';
import actionTypesTutorial from '../../store/tutorial/actionTypes';
import Modal from '../../components/Modal';
import { suitChecker } from '../../utils/game/suitChecker';
import ModalTable from '../../containers/ModalTable/ModalTable';
import { sortCards } from '../../utils/game/sortRandomCards';
import legendItems from '../../utils/legenda';
import { betMinusHandler } from '../../utils/game/positionCircleBetChooser';
import Legend from '../../components/Legend';
import ControlPanel from './ControlPanel';
import ResultPanel from './ResultPanel';
import { positionSelectorGroupedOptions as positions } from './db';
import { TABLE } from '../../utils/tutorialText';
import TutorialMask from '../../components/TutorialMask';
import useWindowDimensions from '../../utils/windowDemensions';
import { getBreakpoints, MATRIX_MODAL } from '../../utils/breakpoints';
import positionArray from './mock';
import MetaDecorator from '../../utils/MetaDecorator';
import { training } from '../../utils/MetaDecorator/meta';
import ResultStatistics from './ResultStatistics';
import cn from 'classnames';
import { useTranslation } from 'react-i18next';
import { useClickOutside } from '../../hooks/useClickOutside';
import RangeGraph from './RangeGraph';
import { ReactComponent as Cross } from 'assets/icons/cross.svg';
import { ReactComponent as Jackdaw } from 'assets/svg/jackdaw.svg';
import { CountdownCircleTimer } from 'react-countdown-circle-timer'
import useChallengeSession from '../../hooks/useChallengeSession';
import TrainerFeedback from '../../components/TrainerFeedback';
import SessionRecap from '../../components/TrainerFeedback/SessionRecap';
import feedbackStyles from '../../components/TrainerFeedback/styles.module.scss';
import useTrainerFeedback from '../../hooks/useTrainerFeedback';

const firstTogglerOptions = [
  { label: 'Low', value: 'low' },
  { label: 'Med', value: 'medium' },
  { label: 'Med+', value: 'high' },
  { label: 'High', value: 'high_plus' },
  // { label: 'MTT POT', value: 'mttpot' },
  // { label: 'MTT 2.25', value: 'mtt2_25x' },
  // { label: 'HU', value: 'hu' },
];

const firstTogglerOptions6MaxPlo5 = [
  { label: 'Low', value: 'low' },
  { label: 'High', value: 'high' },
  { label: 'ANTE POT', value: 'ante' },
  { label: 'ANTE 3.5', value: 'ante3_5x' },
  // { label: 'Straddle', value: 'straddle' },
  // { label: 'Straddle 3x', value: 'straddle3x' },
];

const firstToggleOptionsMttPlo4 = [
  { label: 'MTT POT', value: 'mttpot' },
  { label: 'MTT 2.25', value: 'mtt2_25x' },
  { label: 'MTT ANTE POT', value: 'mttpot_ante' },
  { label: 'MTT ANTE 2.5', value: 'mttx25_ante' },
]

const firstToggleOptionsHu = [
  { label: 'HU', value: 'hu' }
]

const firstTogglerOptionsGG = [
  { label: 'Low', value: 'low' },
  { label: 'High', value: 'high' },
];

const firstTogglerOptionsHUPlo5 = [
  { label: 'Low', value: 'low' },
  { label: 'Med', value: 'medium' },
  { label: 'High', value: 'high' },
];

const secondTogglerOptions = [
  { label: '30', value: '30bb' },
  { label: '50', value: '50bb' },
  { label: '75', value: '75bb' },
  { label: '100', value: '100bb' },
  { label: '200', value: '200bb' },
];

const secondTogglerOptionsHighPlus = [
  { label: '30', value: '30bb' },
  { label: '50', value: '50bb' },
  { label: '75', value: '75bb' },
  { label: '100', value: '100bb' },
];

const secondTogglerOptionsMTTPOT = [
  { label: '10', value: '10bb' },
  { label: '20', value: '20bb' },
  { label: '30', value: '30bb' },
  { label: '40', value: '40bb' },
  { label: '50', value: '50bb' },
];

const secondTogglerOptionsMTTPOT25 = [
  { label: '10', value: '10bb' },
  { label: '20', value: '20bb' },
  { label: '30', value: '30bb' },
  { label: '40', value: '40bb' },
  { label: '50', value: '50bb' },
];

const secondTogglerOptionsGG = [
  { label: '10', value: '10bb' },
  { label: '30', value: '30bb' },
  { label: '50', value: '50bb' },
  { label: '100', value: '100bb' },
]

const secondTogglerOptionsMTT2 = [
  { label: '20', value: '20bb' },
  { label: '30', value: '30bb' },
  { label: '40', value: '40bb' },
  { label: '50', value: '50bb' },
];

const secondTogglerOptionsHU = [
  { label: '20', value: '20bb' },
  { label: '50', value: '50bb' },
  { label: '100', value: '100bb' },
  { label: '150', value: '150bb' },
  { label: '200', value: '200bb' },
];

const secondTogglerOptionsPlo5 = [
  { label: '20', value: '20bb' },
  { label: '50', value: '50bb' },
  { label: '75', value: '75bb' },
  { label: '100', value: '100bb' },
]

const thirdTogglerOptions = [
  { label: 'RFI', value: 'rfi' },
  { label: 'Easy RFI', value: 'easyrfi' },
  { label: 'CC/3BET', value: 'CC/3bet' },
  { label: 'VS 3BET', value: 'vs 3bet' },
  { label: 'SQZ', value: 'SQZ' },
  { label: 'VS SQZ', value: 'VS SQZ' },
  { label: '4BET', value: '4BET' },
  { label: 'VS 4BET', value: 'vs 4bet' }
]

const handTypeOptions = [
  { label: 'Random', value: 'random' },
  { label: 'Del', value: 'del' },
  { label: 'Single Suit, Unpair', value: 'ssup' },
  { label: 'Double Suit, Unpair', value: 'dsup' },
  { label: 'Random Suit, Unpair', value: 'up' },
  { label: 'Del', value: 'del' },
  { label: 'Single Suit, One pair', value: 'ssop' },
  { label: 'Double Suit, One pair', value: 'dsop' },
  { label: 'Random Suit, One pair', value: 'op' },
  { label: 'Del', value: 'del' },
  { label: 'Single Suit, Double pair', value: 'ssdp' },
  { label: 'Random Suit, Double pair', value: 'dp' },
  { label: 'Del', value: 'del' },
  { label: 'A no pair', value: 'anop' },
  { label: 'A with pair', value: 'awithp' },
  { label: 'No AA', value: 'naa' },
  { label: 'No A', value: 'na' },
  { label: 'Del', value: 'del' },
  { label: 'KK', value: 'kk' },
  { label: 'QQ', value: 'qq' },
  { label: 'JJ', value: 'jj' },
  { label: 'TT', value: 'tt' },
  { label: '22-99', value: '22-99' },
];

const difficultyOptions = [
  { label: 'Easy', value: 'easy' },
  { label: 'Default', value: 'default' },
  { label: 'Hard', value: 'hard' }
];

const answerShortcuts = {
  FOLD: '1',
  CALL: '2',
  CHECK: '2',
  RAISE: '3',
};

const TrainingGame = () => {
  const [isSmartMode, setSmartMode] = useState<boolean>(true);
  const [limit, setLimit] = useState<Object>({ label: 'Low', value: 'low' });
  const [stackSize, setStackSize] = useState<Object>({ label: '100', value: '100bb' });
  const [category, setCategory] = useState<Object>({ label: 'RFI', value: 'RFI' });
  const [positionsGrouped, setPositionsGrouped] = useState<any>([]);
  const [disabledPositions, setDisabledPositions] = useState<any>(['sbnolimpvsbb']);
  const [selectedPositions, setSelectedPositions] = useState<any>(['randomRfi']);
  const [selectedHandTypes, setSelectedHandTypes] = useState<any>(['random']);
  const [activeResultTab, setActiveResultTab] = useState<number>(1);
  const [difficulty, setDifficulty] = useState<Object>({ label: 'Default', value: 'default' });
  const [ggps, setGgps] = useState<string>('ps');
  const [selectedPercentsResolver, setSelectedPercentsResolver] = React.useState({ label: '%Action', value: 'action' });
  const [fastHands, setFastHands] = useState<boolean>(false);
  const [isGoodSuit, setIsGoodSuit] = useState<boolean>(false);
  const [timerIsActive, setTimerIsActive] = useState<boolean>(false);
  const [timerSessionStarted, setTimerSessionStarted] = useState<boolean>(false);
  const [timerKey, setTimerKey] = useState<number>(1);
  const [timerCompleted, setTimerCompleted] = useState<boolean>(false);
  const [position, setPosition] = useState<Object>({
    type: 'RFI',
    label: 'EP',
    value: 'ep',
    subValue: 'ep',
    controls: [
      {
        name: 'FOLD',
        customBackground: 'linear-gradient(180.36deg, #535353 0.31%, #272727 99.69%), #898989',
      },
      {
        name: 'RAISE',
        customBackground: 'linear-gradient(180deg, #A54644 0%, #6D1710 100%), linear-gradient(180deg, #A24442 0%, #701A13 100%)',
      },
    ],
  });

  const secondTogglerOptionsSelected = () => {
    if (isPlo5) return secondTogglerOptionsPlo5;
    if (ggps === 'gg') return secondTogglerOptionsGG;
    if (limit.value === 'high_plus') return secondTogglerOptionsHighPlus;
    if (limit.label === 'MTT POT') return secondTogglerOptionsMTTPOT;
    if (limit.label === 'MTT ANTE POT') {
      if (['SQZ', 'VS SQZ'].includes(category.value)) {
        return secondTogglerOptionsMTTPOT;
      }
      return secondTogglerOptionsMTTPOT25;
    }
    if (limit.label === 'MTT ANTE 2.5') return secondTogglerOptionsMTTPOT25;
    if (limit.label === 'MTT 2.25') return secondTogglerOptionsMTT2;
    if (limit.label === 'HU') return secondTogglerOptionsHU;
    return secondTogglerOptions;
  };

  const mttIsDisabled = () => {
    return false;
    // keep there for now
    // const positionsToHide = ['sbnolimpvsbb', 'bbvssbnolimp', 'sbnolimp'];
    // return selectedPositions.length === 1 && positionsToHide.includes(selectedPositions[0])
  };

  const stack20isDisabled = () => {
    return false;
    // keep there for now
    // const positionsToHide = ['sbnolimp', 'bbvssbnolimp', 'sbnolimpvsbb', 'bbvssbnolimp4bet'];
    // return selectedPositions.length === 1 && positionsToHide.includes(selectedPositions[0])
  }

  const huIsDisabled = () => {
    return false;
    // keep there for now
    // const categoriesToHide = ['4BET', 'VS SQZ', 'SQZ'];
    // return categoriesToHide.includes(category.value);
  }

  const [handType, setHandType] = useState<Object>({ label: 'Random', value: 'random' });
  const [isGameAnswerCorrect, setGameAnswerCorrect] = useState<boolean>(false);
  const initialPositions = positions;

  const [isShowText, setIsShowText] = useState<boolean>(false);

  const [disable, setDisable] = useState<boolean>(true);

  const [gameResults, setGameResults] = useState<Array<any>>([]);
  const [isNewHandBtnVisible, setNewHandBtnVisible] = useState<boolean>(false);
  const [isModalVisible, setModalVisible] = useState<boolean>(false);
  const [firstTwoCards, setFirstTwoCards] = useState<string>('');

  const [suit, setSuit] = useState<string>('');
  const [isPlo5, setPlo5] = useState<boolean>(sessionStorage.getItem('isPlo5') === 'true');
  const challengeSession = useChallengeSession({ url: isPlo5 ? '/5card/game/challenge-results' : '/game/challenge-results' });
  const challengeAnswerHandled = useRef(false);
  const nextHandPending = useRef(false);
  const challengeStopPending = useRef(false);
  const challengeStopRequested = useRef(false);
  const [challengeStopping, setChallengeStopping] = useState(false);
  const challengeActiveRef = useRef(false);
  challengeActiveRef.current = challengeSession.active;
  const currentChallengeGameRef = useRef(null);

  const [gameOption, setGameOption] = useState<Object>({ label: '6MAX', value: '6max' });

  const [shadowShow, setShadowShow] = useState<boolean>(false);

  const [searchValue, setSearchValue] = useState<string>('');

  const dispatch = useDispatch();
  const isLoading = useSelector((state) => state.api.SET_CARD_GAME.loading);
  const isLoadingSimilar = useSelector((state) => state?.api?.GET_SIMILAR?.loading);
  const gameData = useSelector((state) => state.game.gameData);
  currentChallengeGameRef.current = gameData;
  const currentStake = useSelector((state) => state.game.stake);
  const option = useSelector((state) => state.game.option);
  const tutorialItemName = useSelector((state) => state.tutorial.name);
  const currentGameTableRef = useSelector((state) => state.game.currentGameTableRef);
  const highestCard = useSelector((state) => state.game.highestCard);
  const cardColor = useSelector((state) => state.game.cardColor);
  const heroColor = useSelector((state) => state.game.heroColor);
  const legenda = useSelector((state) => state.game.legenda);
  const easyLegenda = useSelector((state) => state.game.easyLegenda);
  const opponentPercentage = useSelector((state) => state.game.opponentPercentage);
  const timerAwaitingStart = timerIsActive && !timerSessionStarted;
  const feedback = useTrainerFeedback({
    sessionKey: JSON.stringify([isPlo5, timerIsActive, fastHands, isSmartMode, limit.value, stackSize.value, category.value, gameOption.value, ggps, difficulty.value, selectedPositions, selectedHandTypes]),
  });
  // Finish the hand/animation update before the new cards are painted.
  useLayoutEffect(() => {
    if (gameData.combo && !isLoading && !timerAwaitingStart) feedback.beginHand(gameData);
  }, [gameData, isLoading, timerAwaitingStart, feedback.beginHand]);
  const isCurrentGameTableRefLoaded = useSelector(
    (state) => state.api.SET_CURRENT_GAME_REF.loading,
  );

  const limitIsHU = () => {
    if (isPlo5) return gameOption.value === 'hu';

    return limit.label === 'HU'
  }

  const avoidDelimiters = () => {
    if (limit.value === 'mttpot' || limit.value === 'mttpot_ante' || limit.value === 'mttx25_ante') {
      if (stackSize.value === '10bb' && category.value === 'vs 4bet') {
        return true;
      }
    }
    if (category.value === 'vs 4bet' && stackSize.value === '10bb' && ggps === 'gg') {
      return true;
    }
    return false;
  }

  const handlerSelectedPositions = (action) => {
    if (!action.isChecked && selectedPositions.length === 1) {
      return;
    }

    if (action.isChecked && action.value.includes('random')) {
      setSelectedPositions([action.value]);
      return;
    }

    if (action.isChecked && selectedPositions.length === 1 && selectedPositions[0].includes('random')) {
      setSelectedPositions([action.value]);
      return;
    }

    if (action.isChecked) {
      setSelectedPositions((arr) => [...arr, action.value])
    } else {
      setSelectedPositions((arr) => arr.filter(e => e !== action.value))
    }
  }

  const handlerSelectedHandTypes = (action) => {
    if (!action.isChecked && selectedHandTypes.length === 1) {
      return;
    }

    if (action.isChecked && action.value === 'random') {
      setSelectedHandTypes([action.value]);
      return;
    }

    if (action.isChecked && selectedHandTypes.length === 1 && selectedHandTypes[0] === 'random') {
      setSelectedHandTypes([action.value]);
      return;
    }

    if (action.isChecked) {
      setSelectedHandTypes((arr) => [...arr, action.value])
    } else {
      setSelectedHandTypes((arr) => arr.filter(e => e !== action.value))
    }
  }

  const huValues = [
    'sb', 'sbnolimp', 'bbvssblimp', 'bbvssb', 'bbvssbnolimp',
    'sblimpvsbb', 'sbvsbb', 'sbnolimpvsbb', 'bbvssb4bet', 'bbvssbnolimp4bet'
  ]

  useEffect(() => {
    dispatch({ type: actionTypesProfile.GET_PROFILE_INFO });
    dispatch({ type: actionTypes.GET_CARD_COLOR })
    dispatch({ type: actionTypes.GET_HERO_COLOR })
  }, []);

  useEffect(() => {
    async function checkPlo5(event) {
      // Preferences saved in another tab are not a PLO variant change.
      if (event?.key && event.key !== 'isPlo5') return;
      const item = sessionStorage.getItem('isPlo5');
      if (challengeActiveRef.current) {
        challengeStopPending.current = true;
        try {
          await challengeSession.stop();
        } catch (error) {
          return;
        } finally {
          challengeStopPending.current = false;
        }
        setTimerSessionStarted(false);
        setNewHandBtnVisible(false);
        setTimerCompleted(false);
      }
      setPlo5(item === 'true');
    }

    window.addEventListener('storage', checkPlo5);

    return () => {
      window.removeEventListener('storage', checkPlo5);
    };
  }, []);

  useEffect(() => {
    if (timerIsActive) {
      setFastHands(false);
      setSmartMode(true);
      setSelectedHandTypes(['random'])
    }
    setTimerSessionStarted(false);
    setTimerCompleted(false);
    setNewHandBtnVisible(false);
    setTimerKey((value) => value + 1);
    setGameResults([]);
  }, [timerIsActive]);

  const gameOptions = [
    { label: '6MAX', value: '6max' },
    { label: 'HU', value: 'hu' },
  ]

  const { user } = useSelector((state) => state.profile);
  // const isFreeUser = useSelector((state) => state.profile.free_access)
  const isFreeUser = localStorage.getItem('freeAccess') === 'true';

  const initTrialVersion = () => {
    setDisable(true);
    setLimit({ label: 'Med', value: 'medium' });
    setStackSize({ label: '50', value: '50bb' });
    setPosition({
      type: 'RFI',
      label: 'CO',
      value: 'co',
      subValue: 'co',
      controls: [
        {
          name: 'FOLD',
          customBackground: 'linear-gradient(180.36deg, #535353 0.31%, #272727 99.69%), #898989',
        },
        {
          name: 'RAISE',
          customBackground: 'linear-gradient(180deg, #A54644 0%, #6D1710 100%), linear-gradient(180deg, #A24442 0%, #701A13 100%)',
        },
      ],
    });
  };

  useEffect(() => {
    if (!user?.rate) return;
    if (user?.rate?.toLowerCase() === 'trial') {
      initTrialVersion();
      return;
    }
    setDisable(false);
  }, [user?.rate]);

  useEffect(() => {
    if (ggps === 'mtt') {
      setLimit({ label: 'MTT POT', value: 'mttpot' })
      setStackSize({ label: '50', value: '50bb' });
    } else if (ggps === 'hu') {
      setLimit({ label: 'HU', value: 'hu' })
      setStackSize({ label: '100', value: '100bb' });
    } else {
      setLimit({ label: 'Low', value: 'low' });
      setStackSize({ label: '100', value: '100bb' });
    }
    setCategory({ label: 'RFI', value: 'RFI' })
    setSelectedHandTypes(['random'])
    selectedPositionsHandler();
  },[gameOption, isPlo5, ggps]);

  const setCurrentGameRef = (payload) => {
    payload['ggps'] = ggps;
    payload['isFreeUser'] = isFreeUser;
    isPlo5 ? setFirstTwoCards(`${payload.combo[0][0]}${payload.combo[1][0]}${payload.combo[2][0]}${payload.combo[3][0]}`) : setFirstTwoCards(`${payload.combo[0][0]}${payload.combo[1][0]}`);
    setSuit(suitChecker(payload.combo));
    setModalVisible(true);
    dispatch({
      type: actionTypes.SET_CURRENT_GAME_REF,
      payload,
    });
  };

  const seeRangeMistake = (itemData) => {
    const payload = {
      combo: sortCards(itemData.combo, isPlo5),
      limit,
      position: itemData?.stake?.replace(/ /g, ''),
      stackSize,
      gameOption,
      goodSuit: itemData.good_suit,
      suit: itemData.suit,
      ggps: ggps,
      isFreeUser,
    };

    isPlo5 ? setFirstTwoCards(getFourCardsPlo5(payload.combo[0][0], payload.combo[1][0], payload.combo[2][0], payload.combo[3][0], payload.combo[4][0])) : setFirstTwoCards(`${payload.combo[0][0]}${payload.combo[1][0]}`);
    setSuit(isPlo5 ? itemData.suit : suitChecker(payload.combo));
    setIsGoodSuit(itemData.good_suit);
    setModalVisible(true);
    dispatch({
      type: actionTypes.SET_CURRENT_GAME_REF,
      payload,
    });
  }

  const thirdFourChooser = (card3, card4, card5, firstTwoIsPair) => {
    if (!firstTwoIsPair) {
      return ([card3, card4]);
    }

    if (card3 === card4) {
      return ([card3, card4]);
    }

    const arr = sortRawCards([card3, card4, card5]);
    return ([arr[0], arr[1]]);
  };

  const getFourCardsPlo5 = (card1, card2, card3, card4, card5) => {
    const arr = thirdFourChooser(card3, card4, card5, card1 === card2);
    const card3out = arr[0];
    const card4out = arr[1];
    return `${card1}${card2}${card3out}${card4out}`;
  }

  const seeRange = () => {
    const payload = {
      combo: sortCards(gameData.combo, isPlo5),
      limit,
      position: position?.subValue?.replace(/ /g, ''),
      stackSize,
      gameOption,
      goodSuit: gameData.goodsuit,
      suit: gameData.suit,
      ggps: ggps,
      isFreeUser,
    };

    isPlo5 ? setFirstTwoCards(getFourCardsPlo5(payload.combo[0][0], payload.combo[1][0], payload.combo[2][0], payload.combo[3][0], payload.combo[4][0])) : setFirstTwoCards(`${payload.combo[0][0]}${payload.combo[1][0]}`);
    setSuit(isPlo5 ? gameData.suit : suitChecker(payload.combo));
    setIsGoodSuit(gameData.goodsuit);
    setModalVisible(true);
    dispatch({
      type: actionTypes.SET_CURRENT_GAME_REF,
      payload,
    });
  };

  const apiCallShouldBeExecuted = () => {
    if (isPlo5) return true;
    if (ggps !== 'gg') {
      if ((limit.label === 'MTT POT' || limit.label === 'MTT 2.25') &&
      (stackSize.label === '100' || stackSize.label === '200')) return false;

      if ((limit.label === 'Low' || limit.label === 'Med' || limit.label === 'High') &&
        (stackSize.label === '10' || stackSize.label === '20' || stackSize.label === '40')) return false;

      if ((limit.label === 'HU') && (
          stackSize.label !== '20'
          && stackSize.label !== '50'
          && stackSize.label !== '100'
          && stackSize.label !== '150'
          && stackSize.label !== '200')) return false;

      if (['SQZ', 'VS SQZ', '4BET'].includes(category.value) && limit.label === 'HU') return false;

      // if ((limit.label === 'HU') && (huValues.some(r => selectedPositions.indexOf(r) >= 0))) return false;
      if (selectedPositions.some(r => disabledPositions.indexOf(r) >= 0)) return false;
    }

    return true;
  }

  useEffect(() => {
    if (isPlo5) {
      setGgps('ps')
      hideNoLimpPositions();
      if (category.value === 'VS SQZ') hideEPMPSQZPositions();
      if (gameOption.value === 'hu') hideAllPositionsForHU();
    }

    if (!isPlo5) {
      if (ggps === 'gg') {
        if (category.value === 'vs 4bet' && stackSize.value === '10bb') {
          hideMtt10bbvs4betPositions();
        } else {
          hideNoLimpPositions();
        }
      } else if (stackSize.value === '75bb') {
        hideNoLimpPositions();
      } else if (limit.value === 'high' || limit.value === 'high_plus') {
        hideNoLimpPositions();
      } else if ((limit.value === 'low'
      || limit.value === 'medium'
      || limit.value === 'high_plus') && stackSize.value == '200bb') {
          hideSQZ200bbPositions();
      } else if (limit.value === 'mttpot' || limit.value === 'mtt2_25x' || limit.value === 'mttpot_ante' || limit.value === 'mttx25_ante'){
        if (stackSize.value === '10bb' && category.value === 'vs 4bet') {
          hideMtt10bbvs4betPositions();
        } else {
          hideNoLimpPositions();
          if (category.value === 'VS SQZ' && limit.value === 'mtt2_25x') hideEPMPSQZPositions();
        }
      } else if (limit.value === 'hu') {
        hideAllPositionsForHU()
      } else {
        setDisabledPositions([])
      }
    };

    if (difficultyIsDisabled()) {
      setDifficulty({ label: 'Default', value: 'default' });
    }

    if (limit && stackSize && category && apiCallShouldBeExecuted()) {
      dispatch({
        type: 'SET_CARD_GAME',
        payload: {
          limit,
          stackSize,
          position: selectedPositions,
          handType: selectedHandTypes,
          smartMode: isSmartMode,
          category: category,
          game: gameOption.value,
          ggps: ggps,
          isFreeUser,
          difficulty: difficulty.value,
          timerIsActive,
          challengeResults: timerIsActive,
        },
      });
      setNewHandBtnVisible(false);
      setSearchValue('');
    }
    dispatch({
      type: 'GET_SIMILAR_SUCCESS',
      payload: {
        percentage: null,
        similar: [],
      },
    });

  }, [stackSize, handType, selectedPositions, selectedHandTypes, isPlo5, ggps, difficulty]);

  useEffect(() => {
    if (currentStake) {
      positionHandler(currentStake)
    }
  }, [currentStake])

  useEffect(() => {
    setActiveResultTab(1)
  }, [limit, stackSize, category])

  const positionHandler = (item) => {
    const search = category.value === 'rfi' ? 'RFI' : category.value
    const pos = initialPositions.filter(el => el.label === search)[0].options.filter(el => el.value === item)[0]
    setPosition(pos);
  }

  useEffect(() => {
    const search = category.value === 'rfi' ? 'RFI' : category.value
    const pos = initialPositions.find(el => el.label === search);
    setSelectedHandTypes(['random'])
    setPositionsGrouped(pos);
  }, [category])

  const isMTTAntePot10 = () => {
    if (limit.value === 'mttpot_ante' && stackSize.value === '10bb') {
      return true;
    }
    return false;
  }

  const isMTTAntePotSQZ = () => {
    if (['SQZ', 'VS SQZ'].includes(category.value) && limit.value === 'mttpot_ante') {
      return true;
    }
    return false;
  }

  const difficultyIsDisabled = () => {
    if (difficulty.value !== 'default' && difficultyIsInvalid()) return true;
    return false;
  }

  const difficultyIsInvalid = () => {
    if (isPlo5) return true;
    if (category.value === 'easyrfi') return true;
    return false;
    // if (isPlo5) {
    //   if (category.value === 'vs 4bet' && stackSize.value === '20bb') {
    //     if (gameOption.value === '6max') {
    //       if (limit.value === 'low') return true;
    //       if (limit.value === 'high') return true;
    //     }

    //     if (gameOption.value === 'HU' || gameOption.value === 'hu') {
    //       if (limit.value === 'low') return true;
    //       if (limit.value === 'medium') return true;
    //       if (limit.value === 'high') return true;
    //     }
    //   }
    // } else {
    //   if (category.value === 'vs 4bet') {
    //     if (limit.value === 'mttpot') {
    //       if (stackSize.value === '10bb' || stackSize.value === '20bb' || stackSize.value === '30bb') return true;
    //     }
    //     if (limit.value === 'mtt2_25x') {
    //       if (stackSize.value === '20bb') return true;
    //     }
    //     if (limit.value === 'mttpot_ante') {
    //       if (stackSize.value === '10bb' || stackSize.value === '20bb' || stackSize.value === '30bb') return true;
    //     }
    //     if (limit.value === 'mttx25_ante') {
    //       if (stackSize.value === '10bb' || stackSize.value === '20bb') return true;
    //     }
    //     if (ggps === 'gg') {
    //       if (limit.value === 'low') {
    //         if (stackSize.value === '10bb' || stackSize.value === '30bb') return true;
    //       }
    //       if (limit.value === 'high') {
    //         if (stackSize.value === '10bb' || stackSize.value === '30bb') return true;
    //       }
    //     }
    //     if (ggps === 'ps') {
    //       if (limit.value === 'low') {
    //         if (stackSize.value === '30bb') return true;
    //       }
    //       if (limit.value === 'medium') {
    //         if (stackSize.value === '30bb') return true;
    //       }
    //       if (limit.value === 'high') {
    //         if (stackSize.value === '30bb') return true;
    //       }
    //     }
    //   }

    //   if (category.value === 'vs 3bet') {
    //     if (ggps === 'gg') {
    //       if (limit.value === 'low') {
    //         if (stackSize.value === '10bb') return true;
    //       }
    //       if (limit.value === 'high') {
    //         if (stackSize.value === '10bb') return true;
    //       }
    //     }
    //     if (limit.value === 'mttpot') {
    //       if (stackSize.value === '10bb') return true;
    //     }
    //     if (limit.value === 'mttpot_ante') {
    //       if (stackSize.value === '10bb') return true;
    //     }
    //     if (limit.value === 'mttx25_ante') {
    //       if (stackSize.value === '10bb') return true;
    //     }
    //   }
    // }
  }

  const selectedPositionsHandler = () => {
    switch(category.value) {
      case 'rfi':
        setSelectedPositions(['randomRfi']);
        break;
      case 'easyrfi':
        setSelectedPositions(['randomRfi']);
        break;
      case 'RFI':
        setSelectedPositions(['randomRfi']);
        break;
      case 'CC/3bet':
        setSelectedPositions(['randomCC3Bet']);
        break;
      case 'vs 3bet':
        setSelectedPositions(['randomVs3Bet']);
        break;
      case 'SQZ':
        setSelectedPositions(['randomSqz']);
        break;
      case 'VS SQZ':
        setSelectedPositions(['randomVsSqz']);
        break;
      case '4BET':
        setSelectedPositions(['random4Bet']);
        break
      case 'vs 4bet':
        setSelectedPositions(['randomvs4bet']);
        break;
    };
  }

  useEffect(() => {
    selectedPositionsHandler();
    if (['SQZ', 'VS SQZ'].includes(category.value) && limit.value === 'mttpot_ante' && stackSize.value === '10bb') {
      setStackSize({ label: '50', value: '50bb' });
    }
  }, [category])

  const hideNoLimpPositions = () => {
    const positionsToHide = ['sbnolimpvsbb', 'bbvssbnolimp', 'sbnolimp', 'bbvssbnolimp4bet'];
    setDisabledPositions(positionsToHide);
    removeSelectedPositions(positionsToHide);
  }

  const hideSQZ200bbPositions = () => {
    const positionsToHide = ['epvssqzsb+bb', 'mpvssqzsb+bb', 'covssqzsb+bb', 'epvssqzmp+sb', 'mpvssqzco+sb'];
    setDisabledPositions(positionsToHide);
    removeSelectedPositions(positionsToHide);
  };

  const hideEPMPSQZPositions = () => {
    const positionsToHide = ['epvssqzmp+sb', 'mpvssqzco+sb'];
    setDisabledPositions(positionsToHide);
    removeSelectedPositions(positionsToHide);
  }

  const hideAllPositionsForHU = () => {
    const positionsToHide = [
      'randomRfiNoBlinds', 'ep', 'mp', 'co', 'bu',
      'mpvsep', 'covsep', 'buvsep', 'sbvsep', 'bbvsep', 'covsmp', 'buvsmp', 'sbvsmp', 'bbvsmp', 'buvsco', 'sbvsco',
      'bbvsco', 'sbvsbu', 'bbvsbu', 'epvsmp', 'epvsco', 'epvsbu', 'epvssb', 'epvsbb', 'mpvsco', 'mpvsbu', 'mpvssb',
      'mpvsbb', 'covsbu', 'covssb', 'covsbb', 'buvssb', 'buvsbb',
      'mpvsep4bet', 'covsep4bet', 'buvsep4bet', 'sbvsep4bet', 'bbvsep4bet', 'covsmp4bet', 'buvsmp4bet', 'sbvsmp4bet',
      'bbvsmp4bet', 'buvsco4bet', 'sbvsco4bet',
      'bbvsco4bet', 'sbvsbu4bet', 'bbvsbu4bet', 'epvsmp4bet', 'epvsco4bet', 'epvsbu4bet', 'epvssb4bet', 'epvsbb4bet',
      'mpvsco4bet', 'mpvsbu4bet', 'mpvssb4bet',
      'mpvsbb4bet', 'covsbu4bet', 'covssb4bet', 'covsbb4bet', 'buvssb4bet', 'buvsbb4bet',
    ];

    if (stackSize.value === '20bb' || isPlo5) {
      positionsToHide.push('sbnolimp', 'bbvssbnolimp', 'sbnolimpvsbb', 'bbvssbnolimp4bet')
    }
    setDisabledPositions(positionsToHide);
    removeSelectedPositions(positionsToHide);
  }

  const hideMtt10bbvs4betPositions = () => {
    const positionsToHide = [
      'mpvsep4bet', 'covsep4bet', 'buvsep4bet', 'sbvsep4bet', 'bbvsep4bet', 'covsmp4bet', 'buvsmp4bet', 'sbvsmp4bet',
      'bbvsmp4bet', 'buvsco4bet', 'sbvsco4bet',
      'bbvsco4bet', 'sbvsbu4bet', 'bbvsbu4bet', 'epvsmp4bet', 'epvsco4bet', 'epvsbu4bet', 'epvssb4bet', 'epvsbb4bet',
      'mpvsco4bet', 'mpvsbu4bet', 'mpvssb4bet',
      'mpvsbb4bet', 'covsbu4bet', 'covssb4bet', 'covsbb4bet', 'buvssb4bet', 'buvsbb4bet', 'bbvssbnolimp4bet'
    ];

    setDisabledPositions(positionsToHide);
    removeSelectedPositions(positionsToHide);
  }

  const removeSelectedPositions = (positionsToHide) => {
    const selectedIsDisabled = selectedPositions.some(r => positionsToHide.indexOf(r) >= 0)
    if (selectedIsDisabled) {
      const removedArray = selectedPositions.filter(function(el) {
        return !positionsToHide.includes(el);
      });
      setSelectedPositions(removedArray)
    }
  }

  useEffect(() => {
    if (isPlo5) {
      setStackSize({ label: '100', value: '100bb' });
      selectedPositionsHandler();
      setSelectedHandTypes(['random'])
      return;
    }
    if (limit.value === 'mttpot_ante') {
      if (stackSize.value !== '20bb'
        && stackSize.value !== '30bb'
        && stackSize.value !== '40bb'
        && stackSize.value !== '50bb') {
        setStackSize({ label: '50', value: '50bb' });
      }
    }
    if (limit.value === 'mtt2_25x') {
      if (stackSize.value !== '20bb'
        && stackSize.value !== '30bb'
        && stackSize.value !== '40bb'
        && stackSize.value !== '50bb') {
        setStackSize({ label: '50', value: '50bb' });
      }
    }
    if (limit.value === 'mttpot') {
      if (stackSize.value !== '10bb'
        && stackSize.value !== '20bb'
        && stackSize.value !== '30bb'
        && stackSize.value !== '40bb'
        && stackSize.value !== '50bb') {
        setStackSize({ label: '50', value: '50bb' });
      }
    }
    if (limit.value === 'hu') {
      if (stackSize.value !== '20bb'
        && stackSize.value !== '50bb'
        && stackSize.value !== '100bb'
        && stackSize.value !== '150bb'
        && stackSize.value !== '200bb') {
        setStackSize({ label: '100', value: '100bb' });
      }
      if (['SQZ', 'VS SQZ', '4BET'].includes(category.value)) {
        setCategory({ label: 'RFI', value: 'RFI' })
      }
    }

    if (limit.value === 'high_plus') {
      if (stackSize.value !== '30bb' && stackSize.value !== '50bb' && stackSize.value !== '100bb') {
        setStackSize({ label: '100', value: '100bb' });
      }
    }

    if (limit.value === 'low'
      || limit.value === 'medium'
      || limit.value === 'high') {
      if (stackSize.value !== '30bb'
        && stackSize.value !== '50bb'
        && stackSize.value !== '100bb'
        && stackSize.value !== '200bb') {
        setStackSize({ label: '100', value: '100bb' });
      }
    }
    setSelectedHandTypes(['random'])
    selectedPositionsHandler();
  }, [limit]);

  useEffect(() => {
    if (activeResultTab === 2) {
      dispatch({
        type: 'GET_MISTAKES',
        payload: {
          limit,
          stackSize,
          position: selectedPositions,
          category,
          game: gameOption.value,
          ggps: ggps,
          isFreeUser,
          difficulty: difficulty.value,
        },
      });
    } else {
      dispatch({
        type: 'GET_MISTAKES_CLEAR',
        payload: {}
      });
    }
  }, [activeResultTab, selectedPositions, stackSize]);

  const betCropper = (base, minus) => {
    if (minus > base) return 0;
    if (!base) {
      return null;
    }
    return +base.replace(/\D/g, '') - minus;
  };

  const positionCircles = [
    {
      bet: betCropper(stackSize.label, betMinusHandler(position?.subValue, 'ep', limit?.value, category?.value)),
      position: 'ep',
      positionUp: true,
      selectedPosition: position?.subValue,
    },
    {
      bet: betCropper(stackSize.label, betMinusHandler(position?.subValue, 'mp', limit?.value, category?.value)),
      position: 'mp',
      positionUp: true,
      selectedPosition: position?.subValue,
    },
    {
      bet: betCropper(stackSize.label, betMinusHandler(position?.subValue, 'co', limit?.value, category?.value)),
      position: 'co',
      positionUp: false,
      selectedPosition: position?.subValue,
    },
    {
      bet: betCropper(stackSize.label, betMinusHandler(position?.subValue, 'bu', limit?.value, category?.value)),
      position: 'bu',
      positionUp: false,
      selectedPosition: position?.subValue,
    },
    {
      bet: betCropper(stackSize.label, betMinusHandler(position?.subValue, 'sb', limit?.value, category?.value)),
      position: 'sb',
      positionUp: false,
      selectedPosition: position?.subValue,
    },
    {
      bet: betCropper(stackSize.label, betMinusHandler(position?.subValue, 'bb', limit?.value, category?.value)),
      position: 'bb',
      positionUp: true,
      selectedPosition: position?.subValue,
    },
  ];

  const positionCirclesHU = [
    {
      bet: betCropper(stackSize.label, betMinusHandler(position?.subValue, 'sb', limit?.value, category?.value)),
      position: 'sb',
      positionUp: false,
      selectedPosition: position?.subValue,
    },
    {
      bet: betCropper(stackSize.label, betMinusHandler(position?.subValue, 'bb', limit?.value, category?.value)),
      position: 'bb',
      positionUp: true,
      selectedPosition: position?.subValue,
    },
  ];

  const getIndexSelectedPosition = (myPosition) => {
    if (limit.value === 'hu' || (gameOption.value === 'hu' && isPlo5)) {
      return ['sb', 'bb'].indexOf(myPosition);
    }

    return positionArray.indexOf(myPosition);
  }

  const getStylePosition = (idx) => {
    const pos = idx === 0 ? styles[`position${0}`] : styles[`position${3}`]
    return pos
  }

  const getHUIndex = (idx) => {
    const pos = idx === 0 ? 0 : 3
    return pos
  }

  const handlerPositionOrder = () => {
    const myPosition = position?.subValue?.slice(0, 2) || '';

    const indexSelectedPosition = getIndexSelectedPosition(myPosition);

    const circles = (limit.value === 'hu' || (gameOption.value === 'hu' && isPlo5)) ? positionCirclesHU : positionCircles

    const slice1 = circles.slice(indexSelectedPosition);
    if (slice1.length === 6) return slice1;
    const slice2 = circles.slice(0, indexSelectedPosition);
    return [...slice1, ...slice2];
  };

  const getResultData = (arr) => {
    let right = 0;
    let wrong = 0;
    for (let i = 0; i < arr.length; i += 1) {
      if (arr[i].correct) {
        right += 1;
      } else wrong += 1;
    }
    return {
      right,
      wrong,
      all: right + wrong,
    };
  };

  const checkCorrectAnswer = (ans) => {
    if (timerIsActive && timerCompleted && fastHands) {
      return false;
    }
    if (category.value === 'easyrfi' && gameData.easy_fold) {
      return ans === 'fold';
    } else {
      return gameData.answer.includes(ans);
    }
  }

  const handleGameClick = (ans) => {
    if (!gameData.combo || !currentStake || isLoading || nextHandPending.current || isNewHandBtnVisible || currentChallengeGameRef.current !== gameData) return;
    if (timerIsActive && (!challengeActiveRef.current || currentChallengeGameRef.current !== gameData || challengeAnswerHandled.current || challengeStopPending.current || challengeStopRequested.current || challengeSession.saving || challengeSession.error || !timerSessionStarted)) return;
    const isCorrect = checkCorrectAnswer(ans)
    if (!tutorialItemName && !feedback.recordAnswer(isCorrect, gameData)) return;

    if (timerIsActive) {
      challengeAnswerHandled.current = true;
      challengeSession.saveAnswer({
        correct: isCorrect,
        ts: limit.value,
        bb: stackSize.value,
        stake: currentStake,
        category: category.value.toLowerCase().replace(' ', ''),
        game: gameOption.value,
        gg: !isPlo5 && ggps === 'gg',
        difficulty: difficulty.value,
      }).catch(() => {});
    }

    setGameAnswerCorrect(isCorrect);
    const result = {
      limit,
      stackSize,
      combo: sortCards(gameData.combo, isPlo5),
      answer: ans,
      correct: isCorrect,
      position,
    };
    setGameResults([result, ...gameResults]);
    (fastHands && isCorrect) ? handleNewGameClick(isCorrect) : setNewHandBtnVisible(true);
    getResultData(gameResults);
  };

  const handleNewGameClick = async (isCorrect = null) => {
    if (nextHandPending.current || (timerIsActive && (challengeSession.saving || challengeSession.error || challengeStopPending.current || challengeStopRequested.current))) return;
    nextHandPending.current = true;
    dispatch({ type: 'SET_CARD_GAME_CLEAR' });
    dispatch({
      type: 'SET_CARD_GAME',
      payload: {
        limit,
        stackSize,
        position: selectedPositions,
        handType: selectedHandTypes,
        smartMode: isSmartMode,
        category: category,
        game: gameOption.value,
        timerIsActive: timerIsActive,
        challengeResults: timerIsActive,
        timerCompleted,
        fastMode: fastHands,
        isGameAnswerCorrect: fastHands ? isCorrect : isGameAnswerCorrect,
        ggps: ggps,
        isFreeUser,
        difficulty: difficulty.value,
        currentGame: {
          id: gameData?.id,
          bb: stackSize?.value,
          ts: limit?.value,
          stake: currentStake,
          option: option,
          category: category,
          game: gameOption.value,
          difficulty: difficulty.value,
        }
      },
    });

    setNewHandBtnVisible(false);
    setTimerKey(timerKey+1);
    setTimerCompleted(false);
  };

  useEffect(() => {
    if (!isLoading) {
      nextHandPending.current = false;
      if (!isNewHandBtnVisible) challengeAnswerHandled.current = false;
    }
  }, [isLoading, gameData]);

  const clearChallengeReview = ({ resetFeedback = true } = {}) => {
    if (resetFeedback) feedback.resetSession();
    setGameResults([]);
    setSearchValue('');
    setActiveResultTab(1);
    setGameAnswerCorrect(false);
    dispatch({ type: 'GET_SIMILAR_DROP' });
    dispatch({ type: 'GET_SIMILAR_RESET' });
    dispatch({ type: 'GET_MISTAKES_CLEAR' });
    dispatch({ type: 'GET_MISTAKES_RESET' });
  };

  const handleTimerStart = () => {
    if (isLoading || !gameData.combo || challengeStopPending.current || challengeSession.saving || challengeSession.error) return;
    challengeStopRequested.current = false;
    feedback.prepareAudio();
    challengeSession.start();
    clearChallengeReview();
    challengeAnswerHandled.current = false;
    handleNewGameClick();
    setTimerCompleted(false);
    setNewHandBtnVisible(false);
    setTimerKey((value) => value + 1);
    setTimerSessionStarted(true);
  };

  const handleChallengeStop = async () => {
    if (challengeStopPending.current) return;
    // Stay closed while a failed Stop is retried, including queued timer callbacks.
    challengeStopRequested.current = true;
    challengeStopPending.current = true;
    setChallengeStopping(true);
    try {
      await challengeSession.stop();
      feedback.finishSession();
      clearChallengeReview({ resetFeedback: false });
      setTimerSessionStarted(false);
      setNewHandBtnVisible(false);
      setTimerCompleted(false);
      challengeAnswerHandled.current = false;
      setPlo5(sessionStorage.getItem('isPlo5') === 'true');
      return true;
    } catch (error) {
      // The hook retains the exact pending request for the next Stop retry.
      return false;
    } finally {
      challengeStopPending.current = false;
      setChallengeStopping(false);
    }
  };

  const handleResetGameResults = async () => {
    if (challengeActiveRef.current && !(await handleChallengeStop())) return false;
    feedback.resetSession();
    setGameResults([]);
    return true;
  };

  const answerButtonsDisabled = (
    !gameData.combo
    || isLoading
    || isLoadingSimilar
    || tutorialItemName
    || timerAwaitingStart
    || (timerIsActive && (challengeSession.saving || challengeSession.error || challengeStopPending.current || challengeStopRequested.current))
  );

  const handleAnswerSelect = (answer) => {
    handleGameClick(answer);
    dispatch({
      type: 'GET_SIMILAR',
      payload: {
        limit,
        stackSize,
        position: position.subValue,
        handType: sortCards(gameData.combo, isPlo5)?.map((val) => val?.[0]).join('') || '',
        tableHand: gameData.combo || '',
        category: category.value,
        game: gameOption.value,
        ggps: ggps,
        isFreeUser,
      },
    });
    setSearchValue(sortCards(gameData.combo, isPlo5)?.join('') || '');
  };

  const handleNewHandSelect = async () => {
    dispatch({
      type: 'GET_SIMILAR_SUCCESS',
      payload: {
        percentage: null,
        similar: [],
      },
    });
    setSearchValue('');
    await handleNewGameClick();
  };

  useEffect(() => {
    const handleAnswerShortcut = (event) => {
      const target = event.target;

      if (
        event.repeat
        || target?.closest?.('details, [data-game-settings], [data-trainer-feedback], [data-trainer-session-recap]')
        || event.ctrlKey
        || event.altKey
        || event.metaKey
        || ['INPUT', 'TEXTAREA', 'SELECT'].includes(target?.tagName)
        || target?.isContentEditable
      ) return;

      if (event.code === 'Space' && isNewHandBtnVisible && !tutorialItemName && !isLoading && !challengeSession.saving && !challengeSession.error) {
        if (target?.tagName === 'A') return;
        if (target?.tagName === 'BUTTON' && !target?.textContent?.includes('NEW HAND')) return;
        event.preventDefault();
        handleNewHandSelect();
        return;
      }

      const control = position?.controls?.find((btn) => answerShortcuts[btn.name] === event.key);
      if (!control || answerButtonsDisabled || isNewHandBtnVisible) return;

      event.preventDefault();
      handleAnswerSelect(control.name.toLowerCase());
    };

    window.addEventListener('keydown', handleAnswerShortcut);
    return () => window.removeEventListener('keydown', handleAnswerShortcut);
  });

  useEffect(() => {
    if (activeResultTab === 2 && !isLoading) {
      dispatch({
        type: 'GET_MISTAKES',
        payload: {
          limit,
          stackSize,
          position: selectedPositions,
          category,
          game: gameOption.value,
          ggps: ggps,
          isFreeUser,
          difficulty: difficulty.value,
        },
      });
    }
  }, [isLoading])

  const setTutorialItemName = (name: string) => {
    dispatch({ type: actionTypesTutorial.SET_NAME_TUTORIAL_ITEM, payload: name });
  };

  const handleTitleCardBlock = () => {
    if (tutorialItemName === 'cardButtons') return 'Our possible actions';
    if (tutorialItemName === 'newHandSeeRage') return 'Choice of future actions';
    return '';
  };

  const handleTextCardBlock = () => {
    if (tutorialItemName === 'cardButtons') return '';
    if (tutorialItemName === 'newHandSeeRage') return TABLE.choiceFutureActions;
    if (tutorialItemName === 'newHand') return TABLE.complete;
    return '';
  };

  const handleStyleCardBlock = () => {
    if (tutorialItemName === 'cardButtons') return styles.cardButtons;
    if (tutorialItemName === 'newHandSeeRage') return styles.newHandSeeRage;
    if (tutorialItemName === 'newHand') return styles.newHand;
    return '';
  };

  const { width } = useWindowDimensions();

  const handleCardClick = () => {
    dispatch({ type: actionTypes.UPDATE_CARD_COLOR })
  }

  const handleHeroClick = () => {
    dispatch({ type: actionTypes.UPDATE_HERO_COLOR })
  }

  useEffect(() => {
    if (isShowText && width >= 1024) {
      setIsShowText(false);
    }
  }, [width])

  const style = {
    transform: `scale(${getBreakpoints(MATRIX_MODAL, 'scale', width)})`,
  };

  const handleLegenda = (colors: Array<string>) => (
    colors.map((color) => (
      {
        name: legendItems[color],
        color,
      }
    ))
  );

  const handleEVShow = (type: string) => !!gameData?.[type];

  const dataEV = useMemo(() => [
    {
      isShow: handleEVShow('ev_r'),
      name: 'RAISE',
      type: 'raise',
      ev: gameData?.ev_r || 0,
      weight: gameData?.weight_r || 0,
      value: gameData?.ev_r || 0,
      top: gameData?.top,
    },
    {
      isShow: handleEVShow('ev_f'),
      name: 'FOLD',
      type: 'fold',
      ev: gameData?.ev_f || 0,
      weight: gameData?.weight_f || 0,
      value: gameData?.ev_f || 0,
      top: gameData?.top,
    },
    {
      isShow: handleEVShow('ev_c'),
      name: 'CALL',
      type: 'call',
      ev: gameData?.ev_c || 0,
      weight: gameData?.weight_c || 0,
      value: gameData?.ev_c || 0,
      top: gameData?.top,
    },
    {
      isShow: handleEVShow('ev_c'),
      name: 'CHECK',
      type: 'check',
      ev: gameData?.ev_c || 0,
      weight: gameData?.weight_c || 0,
      value: gameData?.ev_c || 0,
      top: gameData?.top,
    },
  ].sort((a, b) => b.weight - a.weight), [gameData]);

  const exceptions = [
    'high 50bb',
    'high 30bb',
  ];

  const isException = exceptions.includes(`${limit.value} ${stackSize.value}`);

  const handleShow = (ev: string, weight: number) => (
    ((ev?.toString()?.replace('\\/r', '') / 2000).toFixed(3) >= 0)
    || (Math.round(weight.toFixed(1)) > 0)
  );

  const isBBvsSBLimp = position?.value === 'bbvssblimp';

  const dataToShow = dataEV.filter(e => handleShow(e.ev, e.weight))
    .filter(e => !(isBBvsSBLimp && e.type === 'call'))
    .filter(e => !(!isBBvsSBLimp && e.type === 'check'))
    .filter(e => e.weight > 0.3)

  const sum = dataToShow.reduce((s, { weight }) => s + weight, 0);

  if (dataToShow.length > 1) dataToShow[0].weight += (100 - sum);

  const convertSingleResult = (weight: number, value: string) => {
    return `= ${(value / 2000).toFixed(3)} (${parseInt(weight.toFixed(0), 10).toFixed(1)}%)`;
  };

  const handlePercentsResolver = (type: string, top: number, weight: number) => {
    if (type === 'raise' && selectedPercentsResolver.value === 'hands') {
      return (`(${top}%)`);
    }
    if (type === 'fold' && selectedPercentsResolver.value === 'hands') {
      return '';
    }
    return (`(${weight.toFixed(1)}%)`);
  }

  const handleEV = () => (
    dataToShow.map((e) => {
      return (
        e.isShow && (
          <div
            className={styles.ev}
            style={{ color: gameData?.answer?.includes(e.type) ? '#78C93F' : '#A54644' }}
          >
            <div className={styles.EV}>
              EV
            </div>
            <div className={cn(styles.EV, styles?.[e.type])}>
              {category.value === 'easyrfi' && gameData?.easy_fold && e.name === 'FOLD' ? 'FOLD (Easy RFI)' : e.name}
            </div>
            {
              dataToShow.length === 1 && isException
                ? convertSingleResult(e.weight, e.value) : `= ${(e.value / 2000).toFixed(3)} ${handlePercentsResolver(e.type, e.top, e.weight)}`
            }
          </div>
        )
      )
    })
  );

  const chooseFirstTogglerOptions = () => {
    if (!isPlo5 && ggps === 'gg') return firstTogglerOptionsGG;
    if (ggps === 'mtt') return firstToggleOptionsMttPlo4;
    if (ggps === 'hu') return firstToggleOptionsHu;
    if (isPlo5 && gameOption.value === '6max') return firstTogglerOptions6MaxPlo5;
    if (isPlo5 && gameOption.value === 'hu') return firstTogglerOptionsHUPlo5;
    return firstTogglerOptions;
  }

  const handleAnswer = () => {
    if (category.value === 'easyrfi' && gameData?.easy_fold) {
      return (
        <div className={cn(styles.fold, styles.EV)}>
          FOLD (Easy RFI)
        </div>
      )
    }

    if (gameData?.answer?.length === 1) {
      return (
        <div className={cn(styles?.[gameData?.answer[0]], styles.EV)}>
          {gameData?.answer[0]?.toUpperCase()}
        </div>
      )
    }
    return (
      <>
        <div className={cn(styles?.[gameData?.answer?.[0]], styles.EV)}>
          {gameData?.answer?.[0]?.toUpperCase()},
        </div>
        <div className={cn(styles?.[gameData?.answer?.[1]], styles.EV)}>
          {gameData?.answer?.[1]?.toUpperCase()}
        </div>
      </>
    )
  };

  const formRef = useRef<HTMLElement | null>(null);

  const { t } = useTranslation();
  useClickOutside(formRef, () => setIsShowText(false));

  return (
    <div className={styles.trainingGame}>
      <MetaDecorator
        description={training.description}
        title={training.title}
      />
      <Modal
        style={style}
        className={styles.combinationTableSmall}
        isOpen={isModalVisible}
        onClose={() => setModalVisible(false)}
      >
        {currentGameTableRef && currentGameTableRef.length ? (
          <ModalTable
            isDoublesuit={suit === 'double'}
            isRainbow={suit === 'rainbow' || suit === 'mono'}
            selectedCards={firstTwoCards}
            combination={currentGameTableRef}
            isTableLoaded={isCurrentGameTableRefLoaded}
            isEasy={category.value === 'easyrfi'}
            isPlo5={isPlo5}
            highestCard={highestCard}
            isGoodSuit={isGoodSuit}
          />
        )
          : (
            <div className={styles.noTableNotification}>
              <H3>Table is not yet ready</H3>
            </div>
          )}
        <div className={styles.legendWrapper}>
          {handleLegenda(category.value === 'easyrfi' ? easyLegenda : legenda).map((item) => (
            <Legend
              key={item.name}
              name={item.name}
              color={item.color}
            />
          ))}
        </div>
        <a target="_blank" className={styles.linkModal} href={routes.app.FAQ.root}>
          {t('guideTitle9')}
        </a>
      </Modal>
      {shadowShow && <div className={styles.shadow} />}
      <div className={styles.wrapperWrapper}>
      <MobileSettings maxWidth={TRAINER_SETTINGS_MAX_WIDTH}>
      <ControlPanel
        sessionActive={timerSessionStarted || challengeSession.saving}
        isSmartMode={isSmartMode}
        setSmartMode={setSmartMode}
        gameResults={gameResults}
        setGameResults={handleResetGameResults}
        getResultData={getResultData}
        handlerButtonTutorial={() => {
          if (!gameData.combo) return;
          setShadowShow(true);
          setTutorialItemName('limitSelect');
          setGameResults([]);
          setNewHandBtnVisible(false);
          // clearCardGame();
        }}
        disable={disable}
        limit={limit}
        setLimit={setLimit}
        firstTogglerOptions={chooseFirstTogglerOptions()}
        mttIsDisabled={mttIsDisabled()}
        stack20isDisabled={stack20isDisabled()}
        huIsDisabled={huIsDisabled()}
        limitIsHU={limitIsHU()}
        avoidDelimiters={avoidDelimiters()}
        isMTTAntePotSQZ={isMTTAntePotSQZ()}
        isMTTAntePot10={isMTTAntePot10()}
        difficultyIsDisabled={difficultyIsInvalid()}
        stackSize={stackSize}
        setStackSize={setStackSize}
        secondTogglerOptions={secondTogglerOptionsSelected()}
        thirdTogglerOptions={thirdTogglerOptions}
        category={category}
        setCategory={setCategory}
        positionsGroupedOptions={positionsGrouped?.options}
        selectedPositions={selectedPositions}
        setSelectedPositions={handlerSelectedPositions}
        disabledPositions={disabledPositions}
        handType={handType}
        setHandType={setHandType}
        handTypeSelector={handTypeOptions}
        selectedHandTypes={selectedHandTypes}
        setSelectedHandTypes={handlerSelectedHandTypes}
        gameOption={gameOption}
        setGameOption={setGameOption}
        gameOptions={gameOptions}
        isPlo5={isPlo5}
        fastHands={fastHands}
        setFastHands={setFastHands}
        timerIsActive={timerIsActive}
        setTimerIsActive={setTimerIsActive}
        ggps={ggps}
        setGgps={setGgps}
        isFreeUser={isFreeUser}
        difficulty={difficulty}
        setDifficulty={setDifficulty}
        difficultyOptions={difficultyOptions}
      />
      </MobileSettings>
        <Card className={cn(styles.gameWrapper, { [styles.awaitingStart]: timerAwaitingStart })}>
          <ResultStatistics
              isAdaptive
              setGameResults={handleResetGameResults}
              rightResults={getResultData(gameResults).right}
              allResults={getResultData(gameResults).all}
              wrongResults={getResultData(gameResults).wrong}
            />
          <TrainerFeedback {...feedback} />
          <div className={styles.pokerTableWrapper}>
            <div className={styles.pokerTable}>
              {position && handlerPositionOrder().map((item, index) => (
                <PositionCircle
                  index={(limit.value === 'hu' || (gameOption.value === 'hu' && isPlo5)) ? getHUIndex(index) : index}
                  key={item.position}
                  stackSize={stackSize.label}
                  bet={Object.keys(position).length ? item.bet : ''}
                  position={item.position}
                  opponent={position.opponent}
                  opponent2={position?.opponent2 || ''}
                  selectedPosition={position?.subValue}
                  className={(limit.value === 'hu' || (gameOption.value === 'hu' && isPlo5)) ? getStylePosition(index) : styles[`position${index}`]}
                  betOnTable={(Object.keys(position).length && stackSize) ? betMinusHandler(position?.subValue, item.position, limit?.value, category?.value) : ''}
                  hu={limit.value === 'hu' || (gameOption.value === 'hu' && isPlo5)}
                  ante={limit.value === 'ante' || limit.value === 'ante3_5x'}
                  opponentPercentage={opponentPercentage}
                  category={category.value}
                  isLoading={isLoading}
                  isPlo5={isPlo5}
                  cardColor={cardColor}
                  handleCardClick={handleCardClick}
                />
              ))}
              {(limit.value === 'ante' || limit.value === 'ante3_5x') &&
                <div className={cn(styles.anteTitle, styles.translate20)}>
                  Ante: 1.5
                </div>
              }
              {(limit.value === 'mttpot_ante' || limit.value === 'mttx25_ante') &&
                <div className={cn(styles.anteTitle, styles.translate20)}>
                  Ante: 0.8
                </div>
              }
              {/* <div className={`${styles.tableLogo} ${(limit.value === 'ante' || limit.value === 'ante3_5x' || limit.value === 'mttpot_ante' || limit.value === 'mttx25_ante') ? styles.translate10 : ''}`}>
                <H4>
                  OMAHA
                  <span className={styles.tableLogoBlack}>PRO</span>
                  .COM
                </H4>
              </div> */}
            </div>
          </div>
          <SessionRecap recap={feedback.sessionRecap} onDismiss={feedback.dismissRecap} />
          <div className={styles.rangeGraphWrapper}>
            <RangeGraph concealed={timerAwaitingStart} />
          </div>
          <TutorialMask
            className={styles.handControlsTutorial}
            classNamePrompt={styles.fullCardBlock}
            show={tutorialItemName === 'fullCardBlock'}
            title="The result of our action"
            text={TABLE.fullCardBlock}
            zIndex={1000}
            handleButton={
              () => {
                setTutorialItemName('resultPanel');
              }
            }
          >
            <section
              className={cn(styles.cardsAndControls, styles.challengeCardsAndControls)}
              style={{ '--hero-card-count': isPlo5 ? 5 : 4, '--hero-card-width': isPlo5 ? '44px' : '48px' }}
            >
              <div className={styles.evInfo}>
                {!timerAwaitingStart && isNewHandBtnVisible
                  ? handleEV()
                  : ''}
              </div>
              {(limit && stackSize && position && Object.keys(position).length) ? (
                <>
                  <div className={cn(styles.challengeHandRow, {
                    [styles.challengeHandRowActive]: timerIsActive && timerSessionStarted,
                  })}>
                      <div className={styles.challengeTimerSlot}>
                        {(timerIsActive
                          && timerSessionStarted
                          && !isLoading
                          && !isNewHandBtnVisible) && (
                          <div className={styles.timerWrapper}>
                            <CountdownCircleTimer
                              isPlaying={!challengeStopPending.current && !challengeStopRequested.current && !challengeSession.saving && !challengeSession.error && !!gameData.combo}
                              duration={5}
                              colors={['#78C93F']}
                              colorsTime={[5]}
                              size={width > 1300 ? (width >= 2200 ? (width >= 3500 ? 160 : 120) : 80) : 40}
                              trailColor={'#565E6C'}
                              strokeWidth={width > 1300 ? (width >= 2200 ? (width >= 3500 ? 10 : 7) : 5) : 3}
                              key={timerKey}
                              onComplete={() => {
                                if (!challengeActiveRef.current || currentChallengeGameRef.current !== gameData || challengeStopPending.current || challengeStopRequested.current || challengeSession.saving || challengeSession.error || challengeAnswerHandled.current || !timerSessionStarted || isLoading || !gameData.combo) return;
                                setTimerCompleted(true);

                                handleGameClick('false');
                                setNewHandBtnVisible(true);
                                if (isSmartMode) {
                                  // dispatch({
                                  //   type: 'GAME_WRONG',
                                  //   payload: {
                                  //     id: gameData?.id,
                                  //     limit,
                                  //     stackSize,
                                  //     position: position.subValue.replace(/ /g, ''),
                                  //     handType: handType.value,
                                  //     option: option,
                                  //     category: category.value,
                                  //     game: gameOption.value,
                                  //   },
                                  // });
                                  dispatch({
                                    type: 'GET_SIMILAR',
                                    payload: {
                                      limit,
                                      stackSize,
                                      position: position.subValue,
                                      handType: sortCards(gameData.combo, isPlo5)?.map((val) => val?.[0]).join('') || '',
                                      tableHand: gameData.combo || '',
                                      category: category.value,
                                      game: gameOption.value,
                                      ggps: ggps,
                                      isFreeUser,
                                    },
                                  });
                                  setSearchValue(sortCards(gameData.combo, isPlo5)?.join('') || '');
                                }

                              }}
                            >
                              {({ remainingTime }) => <span style={{color: '#FFFFFF', fontSize: `${width > 3500 ? '32px' : '16px'}`}}>{remainingTime}</span>}
                            </CountdownCircleTimer>
                          </div>
                        )}
                      </div>
                    <div className={styles.cardsWrapper}>
                      {!timerAwaitingStart && ((!isLoading || !isLoadingSimilar)
                        ? (
                          <TutorialMask
                            className={styles.challengeCardsTutorial}
                            show={tutorialItemName === 'playingCard'}
                            title="Our starting hand"
                            text=""
                            handleButton={() => setTutorialItemName('cardButtons')}
                          >
                            <div key={feedback.dealId} className={cn(styles.cards, { [feedbackStyles.deal]: feedback.motionEnabled && feedback.dealAnimated && !tutorialItemName })}>
                              <div className={styles.exclamationPointWrap}>
                                {
                                  !isNewHandBtnVisible ? (
                                    width >= 1024 ? (
                                      <>
                                        {gameData?.repeat_count === 1 ? <div className={styles.exclamationPoint}>!</div> : null}
                                        {gameData?.repeat_count === 2 ? <div className={cn(styles.exclamationPoint, styles.exclamationPointRed)}>!</div> : null}

                                        {gameData?.repeat_count === 1 ? <div className={styles.exclamationPointText}>Solve correctly 1 more time to exclude this hand from the repetition list.</div> : null}
                                        {gameData?.repeat_count === 2 ? <div className={styles.exclamationPointText}>You got this hand wrong the previous time, now you need to solve it correctly 2 times.</div> : null}
                                      </>
                                    ) : (
                                      <>
                                        {gameData?.repeat_count === 1 ? <div ref={formRef} onClick={() => setIsShowText(!isShowText)} className={styles.exclamationPoint}>!</div> : null}
                                        {gameData?.repeat_count === 2 ? <div ref={formRef} onClick={() => setIsShowText(!isShowText)} className={cn(styles.exclamationPoint, styles.exclamationPointRed)}>!</div> : null}

                                        {gameData?.repeat_count === 1 ? <div className={cn(styles.exclamationPointTextHide, { [styles.exclamationPointTextShow]: isShowText })}>Solve correctly 1 more time to exclude this hand from the repetition list.</div> : null}
                                        {gameData?.repeat_count === 2 ? <div className={cn(styles.exclamationPointTextHide, { [styles.exclamationPointTextShow]: isShowText })}>You got this hand wrong the previous time, now you need to solve it correctly 2 times.</div> : null}
                                      </>
                                    )
                                  ) : (
                                    isGameAnswerCorrect ? (
                                      <div className={cn(styles.resultIconWrapper, styles.resultGood, { [feedbackStyles.labelCorrect]: feedback.motionEnabled && Boolean(feedback.event) && !tutorialItemName })}><Jackdaw className={styles.jackdaw}/></div>
                                    ) : (
                                      <div className={cn(styles.resultIconWrapper, styles.resultWrong)}><Cross className={styles.cross}/></div>
                                    )
                                  )
                                }

                                {gameData.combo ? sortCards(gameData.combo, isPlo5).map((item) => (
                                    <>
                                      <PlayingCard
                                        cardMaskShow={tutorialItemName && tutorialItemName !== 'playingCard' && tutorialItemName !== 'fullCardBlock'}
                                        key={item}
                                        suit={item[1]}
                                        value={item[0]}
                                        handleClick={handleHeroClick}
                                        heroCard
                                        heroColor={heroColor}
                                      />
                                    </>
                                  ))
                                  : ''}
                              </div>
                            </div>
                          </TutorialMask>
                        )
                        : '')}
                    </div>
                      <div className={styles.challengeStopSlot}>
                        {(timerIsActive && timerSessionStarted) && (
                          <div className={styles.challengeSessionControls}>
                            <Button
                              className={styles.challengeStopButton}
                              onClick={handleChallengeStop}
                              disabled={challengeStopping}
                            >
                              {t('stopLabel')}
                            </Button>
                            {challengeSession.error && <span role="alert">{t('resultsSaveError')}</span>}
                          </div>
                        )}
                      </div>
                  </div>
                    <div key={feedback.event?.id || 0} className={cn(styles.poppingInfo, {
                      [feedbackStyles.labelCorrect]: feedback.motionEnabled && Boolean(feedback.event) && isNewHandBtnVisible && isGameAnswerCorrect && !tutorialItemName,
                      [feedbackStyles.labelWrong]: feedback.motionEnabled && Boolean(feedback.event) && isNewHandBtnVisible && !isGameAnswerCorrect && !tutorialItemName,
                    })}>
                      {!timerAwaitingStart && isNewHandBtnVisible
                        ? (
                          (timerIsActive && timerCompleted) ?
                          <div className={styles.wrong} style={{ color: '#A54644' }}>MISTAKE, OUT OF TIME!</div>
                            :
                          <div className={styles.wrong} style={{ color: isGameAnswerCorrect ? '#78C93F' : '#A54644' }}>
                            {!isGameAnswerCorrect
                              ? <div className={styles.EV}>WRONG.</div> : null}
                            {handleAnswer()}
                            IS THE CORRECT ANSWER
                          </div>
                        )
                        : ''}
                    </div>

                    <TutorialMask
                      className={styles.actionsTutorial}
                      show={tutorialItemName === 'cardButtons' || tutorialItemName === 'newHandSeeRage' || tutorialItemName === 'newHand'}
                      classNamePrompt={handleStyleCardBlock()}
                      title={handleTitleCardBlock()}
                      text={handleTextCardBlock()}
                      positionType="top"
                      handleButton={() => {
                        if (tutorialItemName === 'newHand') {
                          setTutorialItemName('');
                          setShadowShow(false);
                          return;
                        }
                        setTutorialItemName(tutorialItemName === 'cardButtons' ? 'fullCardBlock' : 'seeRangeModal');
                        if (tutorialItemName === 'newHandSeeRage') {
                          seeRange();
                          return;
                        }
                        handleGameClick(position.controls[0].name.toLowerCase());
                      }}
                    >
                    <div
                      className={styles.cardButtonsWrapper}
                    >
                      {/* eslint-disable-next-line no-nested-ternary */}
                      {timerAwaitingStart ? (
                        <div className={styles.timerStartOverlay}>
                          <Button
                            use="ghost"
                            className={styles.timerStartButton}
                            onClick={handleTimerStart}
                            disabled={isLoading || !gameData.combo}
                          >
                            <span className={styles.startButtonContent}>
                              <span className={styles.startPlayIcon} aria-hidden="true" />
                              START
                            </span>
                          </Button>
                        </div>
                      ) : !isNewHandBtnVisible
                        ? ((position && Object.keys(position).length)
                          ? position?.controls?.map((btn) => (
                            <Button
                              buttonMaskShow={tutorialItemName && tutorialItemName !== 'cardButtons' && tutorialItemName !== 'fullCardBlock'}
                              key={btn.name}
                              className={styles.answerButton}
                              customBackground={btn.customBackground}
                              onClick={() => handleAnswerSelect(btn.name.toLowerCase())}
                              disabled={answerButtonsDisabled}
                            >
                              <span className={styles.answerButtonContent}>
                                <span>{btn.name}</span>
                                <span className={styles.answerShortcut}>{answerShortcuts[btn.name]}</span>
                              </span>
                            </Button>
                          )) : '') : (
                            <div key={feedback.event?.id || 0} className={styles.newRangeBtn}>
                              <Button
                                buttonMaskShow={tutorialItemName && tutorialItemName !== 'fullCardBlock' && tutorialItemName !== 'newHand'}
                                className={cn(styles.newHandButton, {
                                  [styles.newHandFeedbackCorrect]: feedback.motionEnabled && Boolean(feedback.event) && isGameAnswerCorrect && !tutorialItemName,
                                  [styles.newHandFeedbackWrong]: feedback.motionEnabled && Boolean(feedback.event) && !isGameAnswerCorrect && !tutorialItemName,
                                })}
                                customBackground="linear-gradient(180.36deg, #535353 0.31%, #272727 99.69%), #898989"
                                onClick={handleNewHandSelect}
                                disabled={tutorialItemName || isLoading || challengeSession.saving || !!challengeSession.error}
                              >
                                <span className={styles.newHandButtonContent}>
                                  <span className={styles.newHandButtonLabel}>NEW HAND</span>
                                  <span className={styles.newHandShortcut}>SPACE</span>
                                </span>
                              </Button>
                              <Button
                                use="ghost"
                                buttonMaskShow={tutorialItemName && tutorialItemName !== 'fullCardBlock' && tutorialItemName !== 'newHandSeeRage'}
                                name="SEE RANGE"
                                onClick={() => seeRange()}
                                disabled={tutorialItemName}
                              />
                            </div>
                        )}
                    </div>
                    </TutorialMask>
                </>
              ) : ''}
            </section>
          </TutorialMask>

        </Card>
      </div>
      <ResultPanel
            setSearchValue={setSearchValue}
            searchValue={searchValue}
            isNewHandBtnVisible={isNewHandBtnVisible}
            gameData={gameData}
            gameResults={gameResults}
            limit={limit || null}
            stackSize={stackSize || null}
            position={position || null}
            setCurrentGameRef={setCurrentGameRef}
            getResultData={getResultData}
            setGameResults={handleResetGameResults}
            activeResultTab={activeResultTab}
            setActiveResultTab={setActiveResultTab}
            category={category}
            gameOption={gameOption}
            isPlo5={isPlo5}
            seeRange={seeRangeMistake}
            ggps={ggps}
            isFreeUser={isFreeUser}
            selectedPercentsResolver={selectedPercentsResolver}
            setSelectedPercentsResolver={setSelectedPercentsResolver}
      />
    </div>
  );
};

export default TrainingGame;
